import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { SysNotifyComponent } from './sysNotify.component';
import { OverlayContainer } from '@angular/cdk/overlay';


@Injectable({ providedIn: 'root' })
export class CustomOverlayContainer extends OverlayContainer {
  protected override _createContainer(): void {
    const container = document.createElement('div');
    container.classList.add('custom-overlay-container');
    container.style.zIndex = '9999';
    document.body.appendChild(container);
    this._containerElement = container;
  }
}

@Injectable({
  providedIn: 'root'
})
export class SysNotifyService {

  constructor(private snackBar: MatSnackBar, private overlayContainer: CustomOverlayContainer) {}

  showSuccess(message: string, duration: number = 3000, horizontalPosition: 'start' | 'center' | 'end' | 'left' | 'right' = 'start', verticalPosition: 'top' | 'bottom' = 'bottom') {
    this.showNotification(message, 'success', duration, horizontalPosition, verticalPosition);
  }

  showError(message: string, duration: number = 3000, horizontalPosition: 'start' | 'center' | 'end' | 'left' | 'right' = 'right', verticalPosition: 'top' | 'bottom' = 'bottom') {
    this.showNotification(message, 'error', duration, horizontalPosition, verticalPosition);
  }

  showWarning(message: string, duration: number = 3000, horizontalPosition: 'start' | 'center' | 'end' | 'left' | 'right' = 'right', verticalPosition: 'top' | 'bottom' = 'bottom') {
    this.showNotification(message, 'warning', duration, horizontalPosition, verticalPosition);
  }

  private showNotification(message: string, type: 'success' | 'error' | 'warning', duration: number, horizontalPosition: 'start' | 'center' | 'end' | 'left' | 'right' = 'end', verticalPosition: 'top' | 'bottom' = 'top') {
    const config: MatSnackBarConfig = {
      duration,
      data: { message, type, horizontalPosition },
      panelClass: [`notification-${type}`, `snackbar-container-${type}`, `notification-bg`, `show-from-${horizontalPosition}`],
      horizontalPosition,
      verticalPosition
    };
    this.snackBar.openFromComponent(SysNotifyComponent, config);
  }
}
